export default {"src":"/_next/static/media/order-center-icon.e3a75eaf.svg","height":14,"width":14};